import http from './http'

/**
 * 查询用户端当前启用的邮箱项目。
 * @returns {Promise}
 */
export const getMailProjects = () => http.post('/mail/projects', {})

/**
 * 查询用户端当前启用的邮箱域名。
 * @returns {Promise}
 */
export const getMailDomains = () => http.post('/mail/domains', {})

/**
 * 查询指定项目和域名的人民币价格及库存。
 * @param {Object} params 项目编码和域名
 * @returns {Promise}
 */
export const getMailPrice = params => http.post('/mail/price', params)

/**
 * 创建邮箱激活订单。
 * @param {Object} params 项目编码和域名
 * @returns {Promise}
 */
export const createMailActivation = params => http.post('/mail/activate', params)

/**
 * 查询邮箱激活验证码和状态。
 * @param {number} activationId 本地邮箱订单 ID
 * @returns {Promise}
 */
export const getMailCode = activationId => http.post('/mail/code', { activationId })

/**
 * 取消尚未收码的邮箱订单。
 * @param {number} activationId 本地邮箱订单 ID
 * @returns {Promise}
 */
export const cancelMailActivation = activationId => http.post('/mail/cancel', { activationId })

/**
 * 查询当前用户的邮箱订单历史。
 * @param {Object} params 分页参数
 * @returns {Promise}
 */
export const getMailOrders = (params = {}) => http.post('/mail/orders', params)

/**
 * 查询当前用户已经收码并完成扣费的邮箱记录。
 * @param {Object} params 分页参数
 * @returns {Promise}
 */
export const getMailHistory = (params = {}) => http.post('/mail/history', params)
